import API from "api/api/API";
import Cookies from "js-cookie";
import TenantAPI from "./TenantAPI";
export default class WorkspaceAPI {
  static async getWorkspaceByID(workspaceID) {
    return API._bearerRequest(
      "get",
      `/tenant/workspaces/${workspaceID}`,
      null,
      Cookies.get(`authenticationToken_${TenantAPI.getCurrentTenant()}`)
    );
  }

  static async getAllWorkspaces() {
    return API._bearerRequest(
      "get",
      "/tenant/workspaces",
      null,
      Cookies.get(`authenticationToken_${TenantAPI.getCurrentTenant()}`)
    );
  }

  static async createWorkspace(payload) {
    return API._bearerRequest(
      "post",
      "/tenant/workspaces",
      payload,
      Cookies.get(`authenticationToken_${TenantAPI.getCurrentTenant()}`)
    );
  }

  static async updateWorkspace(workspaceID, payload) {
    return API._bearerRequest(
      "put",
      "/tenant/workspaces/" + workspaceID,
      payload,
      Cookies.get(`authenticationToken_${TenantAPI.getCurrentTenant()}`)
    );
  }

  static async updateWorkspaceSettings(
    workspaceID,
    payload,
    cloudLevel = false
  ) {
    return API._bearerRequest(
      "put",
      `/tenant/workspaces/${workspaceID}/settings${
        cloudLevel ? "/status" : ""
      }`,
      payload,
      Cookies.get(`authenticationToken_${TenantAPI.getCurrentTenant()}`)
    );
  }

  static async deleteWorkspace(workspaceID) {
    return API._bearerRequest(
      "delete",
      "/tenant/workspaces/" + workspaceID,
      null,
      Cookies.get(`authenticationToken_${TenantAPI.getCurrentTenant()}`)
    );
  }
  // ------------------------- Workspace Join/Leave -------------------------
  static async joinWorkspace(workspaceID) {
    return API._bearerRequest(
      "post",
      `/tenant/workspaces/${workspaceID}/join`,
      null,
      Cookies.get(`authenticationToken_${TenantAPI.getCurrentTenant()}`)
    );
  }

  static async leaveWorkspace(workspaceID) {
    return API._bearerRequest(
      "delete",
      `/tenant/workspaces/${workspaceID}/leave`,
      null,
      Cookies.get(`authenticationToken_${TenantAPI.getCurrentTenant()}`)
    );
  }

  // ------------------------ Workspace User Manangement ------------------------
  static async addWorkspaceUser(workspaceID, userID, permissionProfile) {
    return API._bearerRequest(
      "post",
      `/tenant/workspaces/${workspaceID}/users`,
      { PersonID: userID, PermissionProfile: permissionProfile },
      Cookies.get(`authenticationToken_${TenantAPI.getCurrentTenant()}`)
    );
  }

  static async updateWorkspaceUser(workspaceID, userID, newPermissionProfile) {
    return API._bearerRequest(
      "put",
      `/tenant/workspaces/${workspaceID}/users/${userID}`,
      { PermissionProfile: newPermissionProfile },
      Cookies.get(`authenticationToken_${TenantAPI.getCurrentTenant()}`)
    );
  }

  static async deleteWorkspaceUser(workspaceID, userID) {
    return API._bearerRequest(
      "delete",
      `/tenant/workspaces/${workspaceID}/users/${userID}`,
      null,
      Cookies.get(`authenticationToken_${TenantAPI.getCurrentTenant()}`)
    );
  }

  // ------------------------ Workspace Transfer Ownership ------------------------
  static async transferWorkspaceOwnership(
    workspaceID,
    newUserID,
    permissionProfile
  ) {
    return API._bearerRequest(
      "put",
      `/tenant/workspaces/${workspaceID}/transfer-ownership/${newUserID}`,
      { NewPermissions: permissionProfile },
      Cookies.get(`authenticationToken_${TenantAPI.getCurrentTenant()}`)
    );
  }
}
